import React, { useEffect, useContext } from 'react'
import showdown from 'showdown'
import Navbar from './components/Navbar'
import SectionHome from './sections/SectionHome'
import Footer from './components/Footer'
import SectionIWant from './sections/SectionIWant'
import SectionControl from './sections/SectionControl'
import SectionCardsActive from './sections/SectionCardsActive'
import SectionUseTime from './sections/SectionUseTime'
import SectionRoof from './sections/SectionRoof'
import './App.css'
 
import { AppContext, ACTIONS, initialState } from './store'
import { getPlanPre, getPlanPos, client } from './services/api'

const converter = new showdown.Converter()

export default function App() {
  const { dispatch } = useContext(AppContext)

  async function loadPromotion(){
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: true,
    })

    let planPre
    let planPos

    try {
      planPre = await getPlanPre()
      planPos = await getPlanPos()
    } catch(e){
      planPre = [initialState.plans[0]]
      planPos = [initialState.plans[1]]
    }

    let plans = []
    if(planPre) plans.push(planPre[0])
    if(planPos) plans.push(planPos[0]) 

    const plan = plans.length && plans[0] ? plans[0] : initialState.plans[0]
    const mainBonus = plan.numeroMesesBonificacao
    
    dispatch({
      type: ACTIONS.SET_MAIN_BONUS,
      payload: mainBonus,
    })
  }

  async function loadContentfull() {
    let resp
    try {
      resp = await client.getEntry("1CkZqYvoUV9ROSMMB9JeYT")
      dispatch({
        type: ACTIONS.SET_REGULAMENTO,
        payload: {
          title: resp.fields.promo,
          validity: resp.fields.validade, 
          content: converter.makeHtml(resp.fields.regulamento),
        }
      })
    } catch (error) {
      console.error(error)
    }
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: false
    })
  }

  useEffect(() => {
    loadPromotion()
    loadContentfull()
  }, [])

  return (
    <>
      <Navbar />
      <SectionHome />
      <SectionRoof />
      <SectionUseTime />
      <SectionCardsActive />
      <SectionControl />
      <SectionIWant />
      <Footer />
    </>
  )
}
